import { useAtomValue } from 'jotai';
import { availableTargetsAtom, selectedLabelAtom } from '../../../../../labelling-v2/atoms/relationship-atoms';
import { useStageAtoms } from '../../../../../labelling-v2/components/stage-scope/hooks';
export const useRelationshipTargetValidation = ({
  annotationIdx
}: {
  annotationIdx: string | undefined;
}) => {
  const {
    relationshipEditorOpenAtom
  } = useStageAtoms();
  const isRelationshipEditorOpen = useAtomValue(relationshipEditorOpenAtom);
  const availableRelationshipTargets = useAtomValue(availableTargetsAtom);
  const selectedRelationshipLabel = useAtomValue(selectedLabelAtom);
  const isInvalidRelationshipTarget = !!annotationIdx && isRelationshipEditorOpen && !!selectedRelationshipLabel && annotationIdx !== null && !availableRelationshipTargets.some(t => t.id === annotationIdx);
  return {
    isRelationshipEditorOpen,
    isInvalidRelationshipTarget
  };
};